
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.057 16.277a5.5 5.5 0 11-7.779 7.779 5.5 5.5 0 017.779-7.779z","fill":"#F9B621"}}),_c('path',{attrs:{"d":"M13.057 16.277a5.5 5.5 0 11-7.779 7.779 5.5 5.5 0 017.779-7.779","stroke":"#262626","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M35.056 5.277a5.5 5.5 0 11-7.779 7.779 5.5 5.5 0 017.779-7.779z","fill":"#62AAD8"}}),_c('path',{attrs:{"d":"M35.056 5.277a5.5 5.5 0 11-7.779 7.779 5.5 5.5 0 017.779-7.779","stroke":"#262626","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M35.056 27.275a5.5 5.5 0 11-7.779 7.78 5.5 5.5 0 017.779-7.78z","fill":"#62AAD8"}}),_c('path',{attrs:{"d":"M35.056 27.275a5.5 5.5 0 11-7.779 7.78 5.5 5.5 0 017.779-7.78M14.062 17.71l12.21-6.105M14.062 22.621l12.21 6.105","stroke":"#262626","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    